import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=5c2a2b05&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=ts&"
export * from "./InputPhone.vue?vue&type=script&lang=ts&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=5c2a2b05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a2b05",
  null
  
)

export default component.exports